import LastSignalCinematic from './LastSignalCinematic';

const CoreboundOpening = (props) => (
  <LastSignalCinematic {...props} variant="opening" />
);

export default CoreboundOpening;
